import React, { useState, useRef, useCallback } from "react";
import { makePost } from "@culturehq/client";

import { useAsyncAction } from "app/hooks";

import RecognizeSelectUsers from "./recognize/RecognizeSelectUsers";
import RecognizeSelectType from "./recognize/RecognizeSelectType";
import RecognizeWriteBody from "./recognize/RecognizeWriteBody";

const filterUser = (users, user) => users.filter(current => current.id !== user.id);

const Recognize = ({ initialUsers, onCreate }) => {
  const editorRef = useRef();

  const [step, setStep] = useState(initialUsers.length > 0 ? 1 : 0);
  const [users, setUsers] = useState(initialUsers);
  const [type, setType] = useState(null);
  const [values, setValues] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState();

  const { onTrigger: onSubmit } = useAsyncAction(
    useCallback(
      async () => {
        await makePost("/recognitions", {
          userIds: users.map(({ id }) => id),
          recognitionTypeId: type.id,
          organizationValueIds: values,
          body: await editorRef.current.serialize(),
          slackChannel: selectedChannel
        });
        onCreate();
      },
      [onCreate, type, users, values, selectedChannel]
    )
  );

  const onNextClicked = () => setStep(current => current + 1);
  const onPrevClicked = () => setStep(current => current - 1);

  if (step === 0) {
    const onUserDeselected = user => setUsers(current => filterUser(current, user));
    const onUserSelected = user => setUsers(current => filterUser(current, user).concat(user));

    return (
      <RecognizeSelectUsers
        users={users}
        onUserSelected={onUserSelected}
        onUserDeselected={onUserDeselected}
        onNextClicked={onNextClicked}
      />
    );
  }

  if (step === 1) {
    const onTypeSelected = nextType => {
      setType(nextType);
      onNextClicked();
    };

    return (
      <RecognizeSelectType
        users={users}
        onPrevClicked={onPrevClicked}
        onTypeSelected={onTypeSelected}
      />
    );
  }

  const onValueDeselected = newValues => setValues(newValues);
  const onValueSelected = newValues => setValues(newValues);

  const onSelectedChannel = channel => {
    setSelectedChannel(channel);
  };

  return (
    <RecognizeWriteBody
      type={type}
      users={users}
      values={values}
      onPrevClicked={onPrevClicked}
      onSubmit={onSubmit}
      onValueSelected={onValueSelected}
      onValueDeselected={onValueDeselected}
      editorRef={editorRef}
      onSelectedChannel={onSelectedChannel}
    />
  );
};

export default Recognize;
